import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendEmail } from '../../store/thunks/leadsActions';
import { sendInquiryEmail } from '../../store/thunks/inquiriesActions';
import EmailMessageBubble from './EmailMessageBubble';

export default function EmailThread({
  messages,
  leadId,
  inquiryId,
  onReply,
  campaignId,
  campaignLeadId,
}) {
  const dispatch = useDispatch();
  const adminInfo = useSelector((state) => state.login?.adminInfo || {});
  const [replyingTo, setReplyingTo] = useState(null);
  const [replyBody, setReplyBody] = useState('');

  if (!messages?.length) {
    return <p className="text-sm text-[#6B7280]">No messages yet.</p>;
  }

  const handleInlineReply = async (message) => {
    const payload = {
      from: adminInfo.gmail || adminInfo.gmailPrimaryAddress || adminInfo.email || '',
      to: Array.isArray(message.from) ? message.from.join(', ') : message.from,
      subject: message.subject || '',
      body: replyBody,
      threadId: message.threadId,
    };

    if (leadId) {
      await dispatch(
        sendEmail({
          leadId,
          campaignId,
          campaignLeadId,
          ...payload,
        })
      ).unwrap();
      return;
    }

    if (inquiryId) {
      await dispatch(
        sendInquiryEmail({
          id: inquiryId,
          ...payload,
        })
      ).unwrap();
    }
  };

return (
  <div className="space-y-6">
    {messages.map(m => {
      const key = m.messageId || m.timestamp;
      const isInbound = m.direction === 'inbound';
      const isReplyBoxOpen = replyingTo === key;

      return (
        <div key={key} className="relative">
          <div className="group">
            <EmailMessageBubble message={m} />

            {isInbound && (
              <button
                onClick={() => {
                  if (onReply) {
                    onReply({
                      threadId: m.threadId,
                      from: Array.isArray(m.from) ? m.from.join(', ') : m.from,
                      subject: m.subject,
                    });
                    return;
                  }
                  setReplyingTo(isReplyBoxOpen ? null : key);
                }}
                className="
                  absolute top-2 right-2 text-xs text-[#2563EB] font-medium
                  opacity-0 group-hover:opacity-100 transition-opacity duration-200
                "
              >
                {onReply ? 'Reply' : isReplyBoxOpen ? 'Cancel' : 'Reply'}
              </button>
            )}
          </div>

          {isInbound && isReplyBoxOpen && !onReply && (
            <div className="mt-3 ml-6 space-y-3">
              <textarea
                rows={4}
                value={replyBody}
                onChange={e => setReplyBody(e.target.value)}
                placeholder="Type your reply…"
                className="
                  w-full p-3 text-sm border border-[#D1D5DB] rounded-[12px]
                  text-[#1F2937] placeholder-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#2563EB]
                "
              />
              <button
                onClick={() => {
                  handleInlineReply(m)
                    .then(() => {
                      setReplyBody('');
                      setReplyingTo(null);
                    })
                    .catch(console.error);
                }}
                disabled={!replyBody.trim()}
                className={`
                  px-4 py-2 rounded-[12px] text-sm font-medium transition-colors duration-150
                  ${!replyBody.trim()
                    ? 'bg-[#9CA3AF] text-white cursor-not-allowed'
                    : 'bg-[#2563EB] text-white hover:bg-[#1D4ED8]'
                  }
                `}
              >
                Send
              </button>
            </div>
          )}
        </div>
      );
    })}
  </div>
);

}
